import { ThemeProvider } from "styled-components";
import { useState } from "react";
import { darkTheme, lightTheme } from './utils/Themes.js'
import Navbar from "./components/Navbar";
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import HeroSection from "./components/HeroSection";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Experience from "./components/Experience";
import Education from "./components/Education";
import ProjectDetails from "./components/ProjectDetails";
import ChatAssistant from "./components/ChatAssistant";
import styled from "styled-components";
import { Toaster } from 'react-hot-toast';

const Body = styled.div`
  background: ${({ theme }) => theme.bg};
  width: 100%;
  overflow-x: hidden;
  position: relative;
`

const Wrapper = styled.div`
  background: linear-gradient(
    38.73deg,
    rgba(99, 102, 241, 0.07) 0%,
    rgba(99, 102, 241, 0) 50%
  ),
  linear-gradient(
    141.27deg,
    rgba(124, 106, 247, 0) 50%,
    rgba(124, 106, 247, 0.07) 100%
  );
  width: 100%;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 30% 98%, 0 100%);
`

function App() {
  const [darkMode] = useState(true);
  const [openModal, setOpenModal] = useState({ state: false, project: null });

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <Router>
        <Navbar />
        <Body>
          <HeroSection />
          <Wrapper>
            <Skills />
            <Experience />
          </Wrapper>
          <Projects openModal={openModal} setOpenModal={setOpenModal} />
          <Wrapper>
            <Education />
            <Contact />
          </Wrapper>
          <Footer />
          {openModal.state &&
            <ProjectDetails openModal={openModal} setOpenModal={setOpenModal} />
          }
        </Body>
        <ChatAssistant />
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#1C1C27',
              color: '#F2F3F4',
              borderRadius: '12px',
              fontSize: '14px',
              border: '1px solid rgba(133, 76, 230, 0.2)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
            },
            success: {
              duration: 5000,
              iconTheme: { primary: '#4ade80', secondary: '#fff' },
            },
            error: {
              duration: 5000,
              iconTheme: { primary: '#ef4444', secondary: '#fff' },
            },
            loading: {
              iconTheme: { primary: '#854CE6', secondary: '#fff' },
            },
          }}
        />
      </Router>
    </ThemeProvider>
  );
}

export default App;
